import React from 'react'
import { Link } from 'gatsby'
import styled from 'styled-components'
import Plaatjie from '@ubo/plaatjie'
import parse from 'html-react-parser'

const Card = styled(Link)`
  display: block;
  position: relative;
  max-width: 480px;
  margin-inline: auto;
  text-decoration: none;

  &:hover .project-link {
    text-decoration: none;
  }
`

const Image = styled(Plaatjie)`
  width: 100%;

  @media (min-width: 992px) {
    height: 322px;
  }

  @media (max-width: 991.98px) {
    height: 240px;
  }
`

const Box = styled.div`
  position: relative;
  background-color: ${(props) => props.theme.color.main};
  width: 83.33%;
  margin-left: 16.67%;

  /* Notched bottom-right corner */
  &::after {
    position: absolute;
    content: '';
    right: 0;
    bottom: 0;
    width: 0;
    height: 0;
    border-top: 35px solid transparent;
    border-right: 35px solid #fff;
    z-index: 2;
  }

  @media (min-width: 992px) {
    margin-top: -38px;
    padding: 11px 25px 9px;
  }

  @media (max-width: 991.98px) {
    margin-top: -30px;
    padding: 15px 20px;

    &::after {
      border-top-width: 25px;
      border-right-width: 25px;
    }
  }
`

const Title = styled.h3`
  font-family: ${(props) => props.theme.font.family.secondary};
  color: #fff;
  text-transform: uppercase;
  font-weight: 500;
  margin: 0;

  & i {
    font-style: normal;
    font-weight: 200;
  }

  @media (min-width: 992px) {
    font-size: 30px;
    line-height: 39px;
  }

  @media (max-width: 991.98px) {
    font-size: 22px;
    line-height: 28px;
  }
`

const ProjectLink = styled.span`
  display: inline-block;
  color: #d50021;
  text-decoration: underline;
  margin-top: 0.25rem;

  @media (min-width: 992px) {
    font-size: 16px;
    line-height: 29px;
  }

  @media (max-width: 991.98px) {
    font-size: 14px;
  }
`

function ProjectCardLanding({ src, title, location, to }) {
  return (
    <Card to={to}>
      <Image image={src} alt="" />

      <Box>
        <Title>
          {parse(title)}
          {location && (
            <>
              {' - '}
              <i>{parse(location)}</i>
            </>
          )}
        </Title>
        <ProjectLink className="project-link">Bekijk project &gt;</ProjectLink>
      </Box>
    </Card>
  )
}

export default ProjectCardLanding
